module.exports = __webpack_public_path__ + "img/584.797490f2.jpg";